import React from 'react';
import { Typography } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { observer } from 'mobx-react-lite';
import { Modal, ModalCancelButton, ModalProgressButton, ModalActions, ModalContent } from '../../../Modal';
import { useAutoLogoutNotification } from './auto-logout-notification.hooks';


export type AutoLogoutNotificationModalProps = {
  enabled?: boolean;
};


export const AutoLogoutNotificationModal: React.FC<AutoLogoutNotificationModalProps> = observer(({ enabled = true }) => {
  const { isOpened, handleStayLoggedIn, handleLogout } = useAutoLogoutNotification(enabled);
  const l10n = useL10n();

  return (
    <Modal maxWidth="md" fullWidth title={l10n.general.autoLogout.modalNotification.title} open={isOpened || false} onClose={handleStayLoggedIn}>
      <ModalContent>
        <Typography>
          {l10n.general.autoLogout.modalNotification.content}
        </Typography>
      </ModalContent>
      <ModalActions>
        <ModalCancelButton onClick={handleLogout} color="primary">{l10n.general.autoLogout.modalNotification.logout}</ModalCancelButton>
        <ModalProgressButton variant="contained" color="primary" onClick={handleStayLoggedIn}>{l10n.general.autoLogout.modalNotification.stayLoggedIn}</ModalProgressButton>
      </ModalActions>
    </Modal>
  );
});
